import styled from 'styled-components';
export const NavRoot = styled.nav`
   padding: 1.2rem 0.3rem;
   display: flex;
   align-items: center;
   width: 100vw;
   height: 40px;
   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
   color:  #023e8a;
`

export const LogoStyled = styled.img`
   margin: 5px 4px;
   height: 30px;
`